(() => {
  const replacement = "https://cdn.shopify.com/s/files/1/0597/4589/4593/files/branche-holiday-open-gift-box.jpg?v=1793036895";
  const originalName = "BRANCHE_HOLIDAY_BOX002_web.png";
  let queued = false;
  function updateGiftPhoto() {
    queued = false;
    document.querySelectorAll(".effective-apps-egw-modal img").forEach((image) => {
      if (!(image.getAttribute("src") || "").includes(originalName)) return;
      image.src = replacement;
      image.removeAttribute("srcset");
      image.alt = "Branché gift box styled with silk gifts and a candle. Contents sold separately.";
      image.style.objectFit = "contain";
    });
  }
  function scheduleUpdate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(updateGiftPhoto);
  }
  updateGiftPhoto();
  new MutationObserver(scheduleUpdate).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ["src", "srcset"]
  });
})();

// The Mailchimp signup form uses an open shadow root; the gift-wrap dialog above is separate.
(() => {
  const hostSelector = "#mcforms-328306-386537";
  const photoSelector = "#el_qxnrhqsAfX #el_aZCv1xqc21, #el_qxnrhqsAfX #el_icxD7p1E3g";
  const replacement = "https://cdn.shopify.com/s/files/1/0597/4589/4593/files/branche-signup-holiday-gift-box.jpg?v=1793118159";
  const originalPhotos = [
    "12fdfd628c3b7af6ead49c4fa536ca07.webp",
    "b49e236fbb231bfacca1164ad9a9408c.webp"
  ];
  const observedRoots = new WeakSet();

  function updatePhotos(root) {
    root.querySelectorAll(photoSelector).forEach((photo) => {
      const background = getComputedStyle(photo).backgroundImage;
      if (!originalPhotos.some((name) => background.includes(name))) return;
      photo.style.setProperty("background-image", 'url("' + replacement + '")', "important");
      photo.style.setProperty("background-position", "center center", "important");
      photo.style.setProperty("background-size", "cover", "important");
    });
  }

  function connectSignupForm() {
    const host = document.querySelector(hostSelector);
    const root = host && host.shadowRoot;
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    updatePhotos(root);
    new MutationObserver(() => updatePhotos(root)).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }

  connectSignupForm();
  new MutationObserver(connectSignupForm).observe(document.body, {
    childList: true,
    subtree: true
  });
  // Shadow roots can attach after the host has already entered the document.
  let attempts = 0;
  const initialCheck = setInterval(() => {
    connectSignupForm();
    if (++attempts >= 120 || document.querySelector(hostSelector)?.shadowRoot) {
      clearInterval(initialCheck);
    }
  }, 500);
})();
